export const maskAccount = (account: string | null | undefined) => {
  if (!account) return ''

  const cleanAccount = String(account).replace(/\D/g, '')
  const lastFour = cleanAccount.slice(-4)

  return `**** **** ${lastFour}`
}
